module.exports = __webpack_public_path__ + "img/Jump Casting99.3bfa1058.jpg";